export const SHOW_SIDEBAR = 'SHOW_SIDEBAR'
export const HIDE_SIDEBAR = 'HIDE_SIDEBAR'
export const DATA_SIDEBAR = 'DATA_SIDEBAR'
export interface ShowSidebar {
  type: typeof SHOW_SIDEBAR
  payload: string
}

export interface HideSidebar {
  type: typeof HIDE_SIDEBAR
  payload: null
}

export interface DataSidebar {
  type: typeof DATA_SIDEBAR
  payload: any
}

export interface State {
  visibleSidebar: string | null
}

export const initialState: State = {
  visibleSidebar: null,
}

export type Actions = ShowSidebar | HideSidebar
